import omniEntity from './reducers';

import * as omniEntityOperations from './operations';
import * as omniEntityTypes from './types';

export { omniEntityOperations, omniEntityTypes };

export default omniEntity;
